import React from 'react';
import PropTypes from 'prop-types';
import DialogWithErrorLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithErrorLayout';

import './ActivationErrorDialog.scss';

export const remoteAccessActivationErrorDialogMessage = 'An error has occurred during your remote access activation.';

function ActivationErrorDialog({ message, ...otherProps }) {
  return (
    <DialogWithErrorLayout
      {...otherProps}
      size="md"
      header="Remote access activation error"
      className="remote-access-activation-error-dialog"
      contentClassName="remote-access-activation-error-dialog__content">
      {message || remoteAccessActivationErrorDialogMessage}
    </DialogWithErrorLayout>
  );
}

ActivationErrorDialog.propTypes = {
  message: PropTypes.string,
};

export default ActivationErrorDialog;
